module.exports = __webpack_public_path__ + "static/media/not-found.6fa76661.jpg";